module.exports = __webpack_public_path__ + "static/img/patrick-tomasso-2R5QtSqJtdY-unsplash_thumb.f35e154.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/patrick-tomasso-2R5QtSqJtdY-unsplash_thumb.png
// module id = dpOS
// module chunks = 4